/**
 * @enum {number}
 */
var SnapLineType = {
    TO      :   0,
    FROM    :   1,
    ROUTETO :   2
};

module.exports = SnapLineType;
